export const HomePageInfo = {
  myTitle: "I’m Sabata",
  myProfession: "Software Engineer | Full-Stack & DevOps",
  myWorkJourney:
    "Full-stack engineer with 6+ years building end-to-end web solutions across React/Next.js and Node.js/Python back ends. Comfortable owning microservices, REST APIs, and CI/CD on AWS with Docker/Kubernetes.",
};
